export default __webpack_public_path__ + "static/media/boost.f805684a.svg";